import React from 'react';
import { useForm } from 'react-hook-form';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import type PostOpportunityConfidenceLevel from '@/types/api/PostOpportunityConfidenceLevel';
import type PutOpportunityConfidenceLevel from '@/types/api/PutOpportunityConfidenceLevel';

type UseConfidenceLevelFormProps = {
  amount: number;
  name: string;
};

export default function useConfidenceLevelForm({
  amount,
  name,
}: UseConfidenceLevelFormProps) {
  const ownerOrgId = useOwnerOrgId();

  const defaultValues = React.useMemo(
    () => ({
      amount,
      name,
      ownerOrgId,
    }),
    [ownerOrgId],
  );

  const formMethods = useForm<
    PutOpportunityConfidenceLevel | PostOpportunityConfidenceLevel
  >({
    defaultValues,
  });

  const { reset } = formMethods;

  React.useEffect(() => {
    reset(defaultValues);
  }, [reset, defaultValues]);

  return {
    formMethods,
    defaultValues,
  };
}
